import css from './wordListFilters.module.scss';

import KeyBind from 'core/ui/KeyBind';
import { Icon } from 'core/ui/icons';

export const SearchInput = ({
  value,
  onChange,
}: {
  value: string;
  onChange: (text: string) => void;
}) => (
  <input
    type="text"
    placeholder="Search..."
    className={css.searchInput}
    value={value}
    onChange={evt => onChange(evt.target.value)}
  />
);

export const SearchButton = ({ onClick }: { onClick: () => void }) => (
  <Icon icon="Magnifier" className={css.filterButton} onClick={onClick} />
);

export const AddWord = ({ onClick }: { onClick: () => void }) => (
  <>
    <Icon icon="Plus" className={css.filterButton} onClick={onClick} />
    <KeyBind onKeyDown={onClick} kkb={['F2', 'Shift+Equal']} />
  </>
);

export const AddWords = ({ onClick }: { onClick: () => void }) => (
  <Icon icon="PlusMultiple" className={css.filterButton} onClick={onClick} />
);
